import { createSwitchNavigator } from "@react-navigation/core";
import { lazy } from "react";

import withAuth from "../component/Login/Auth";

const Login = lazy(() => import("../container/User/Login"));
const CreateInvoiceScreen = lazy(() => import("../screen/CreateInvoice"));
const DashboardScreen = lazy(() => import("../screen/Dashboard"));
const JobListListingScreen = lazy(() => import("../screen/JobListListing"));
const JobListListingScreenV1 = lazy(() => import("../screen/JobListListingV1"));
const JobCardScreen = lazy(() => import("../screen/JobCardScreen"));
const JobCardScreenV1 = lazy(() => import("../screen/JobCardScreenV1"));
const InvoiceListingScreen = lazy(() => import("../screen/InvoiceListingScreen"));
const InvoiceListingScreenV3 = lazy(() => import("../screen/v3/InvoiceListingScreenV3"));
const JobCardListingScreen = lazy(() => import("../screen/JobCardListingScreen"));
const JobCardListingScreenV1 = lazy(() => import("../screen/JobCardListingScreenV1"));
const InventoryListingScreen = lazy(() => import("../screen/InventoryListingScreen"));
const InventoryListingScreenV1 = lazy(() => import("../screen/InventoryListingScreenV1"));
const TicketDetailScreen = lazy(() => import("../screen/TicketDetailScreen"));
const ThreeSixtyViewUploadScreen = lazy(() => import("../screen/ThreeSixtyViewUploadScreen"));
const ThreeSixtyViewScreen = lazy(() => import("../screen/ThreeSixtyViewScreen"));
const ThreeSixtyInteriorViewScreen = lazy(() => import("../screen/ThreeSixtyInteriorViewScreen"));
const WorkshopListingScreen = lazy(() => import("../screen/WorkshopListingScreen"));
const UpComingInventoryScreen = lazy(() => import("../screen/UpComingInventoryScreen"));
const SparePartsScreen = lazy(() => import("../screen/SparePartsScreen"));
const UpComingInventoryScreenV1 = lazy(() => import("../screen/UpComingInventoryScreenV1"));
const InvoiceListingScreenV1 = lazy(() => import("../screen/InvoiceListingScreenV1"));
const CreateInvoiceV1 = lazy(() => import("../screen/CreateInvoiceV1"));
const DashboardV3 = lazy(() => import("../screen/v3/DashboardV3"));
const InventoryListingV3 = lazy(() => import("../screen/v3/InventoryListingV3"));
// const InventoryListingV3New = lazy(() => import("../screen/v3/InventoryListingV3.1"));
import InventoryListingV3New from "../screen/v3/InventoryListingV3.1";
const ReceivePartsTO = lazy(() => import("../screen/v3/SparePartModules/ReceivePartsTO"));
const RaiseRequest = lazy(() => import("../screen/v3/SparePartModules/RaiseRequest"));
const ReceivePartsVendor = lazy(() => import("../screen/v3/SparePartModules/ReceivePartsVendor"));
const UpcomingInventoryListingV3 = lazy(() => import("../screen/v3/UpcomingInventoryListingV3"));
// const JobCardListingV3 = lazy(() => import("../screen/v3/JobCardListingV3"));
import JobCardListingV3 from '../screen/v3/JobCardListingV3'
const WorkshopDashboard = lazy(() => import("../screen/v3/WorkshopDashboard"));
const Purchase = lazy(() => import("../screen/v3/Purchase/Purchase"));
const PendingConfirmation = lazy(() => import("../src/screens/PendingConfirmation"));
const PendingInvoicing = lazy(() => import("../src/screens/PendingInvoicing"));
const PendingReceiving = lazy(() => import("../src/screens/PendingReceiving"));
const OpenMarket = lazy(() => import("../src/screens/OpenMarket"));
const OpenMarketConfirmation = lazy(() => import("../src/screens/OpenMarketConfirmation"));
const JobListListingScreenV3 = lazy(() => import("../screen/v3/JobListListingScreenV3"));
const CarRefurbMetrics = lazy(() => import("../screen/v3/CarRefurbMetrics"));
const ConfirmParts = lazy(() => import("../src/screens/ConfirmParts"));
const PMInvoice = lazy(() => import("../src/screens/PMInvoice"));
const InventoryReplenishment = lazy(() => import("../src/screens/InventoryReplenishment"));
const InvenRepPurchaseRequest = lazy(() => import("../src/screens/InvenRepPurchaseRequest"));
const PurchaseRequestByCar = lazy(() => import("../src/screens/PurchaseRequestByCar"));
const InvenRepEditPurchaseRequest = lazy(() => import("../src/screens/InvenRepEditPurchaseRequest"));
const PMSubmittedInvoiceDetails = lazy(() => import("../src/screens/PMSubmittedInvoiceDetails"));
const Budget = lazy(() => import("../screen/v3/BudgetModule/Budget/Budget"));
const BudgetDetails = lazy(() => import("../screen/v3/BudgetModule/BudgetDetails/BudgetDetails"));
const ByCarV2 = lazy(() => import("../src/screens/v2/ByCarV2"));
const AlternatePartV2 = lazy(() => import("../src/screens/v2/AlternatePartV2"));
const Inspections = lazy(() => import("../screen/v3/InspectionAuditModule/Inspections/Inspections"));
const InspectionDetails = lazy(() => import("../screen/v3/InspectionAuditModule/InspectionDetails/InspectionDetails"));
const CatalogueRequests = lazy(() => import("../src/screens/v2/CatalogueRequests"));
const Warranty = lazy(() => import("../src/screens/warranty"));
const NoAccess = lazy(() => import("../screen/v3/NoAccess"));
const ManPower = lazy(()=> import('../src/screens/ManPower'));
const Dispute = lazy(() => import("../src/screens/Harmony/Dispute"));
const Resolution = lazy(() => import("../src/screens/Harmony/Resolution"));
const ResolutionManagementDetail = lazy(() => import("../src/screens/Harmony/Resolution/ResolutionManagementDetail"));
const DisputeManagementDetail = lazy(() => import("../src/screens/Harmony/Dispute/DisputeManagementDetail"));
const Outbound = lazy(() => import("../outbound/screens/Outbound"));
const OutboundDashboard = lazy(() => import("../screen/OutboundDashboardScreen"));
const ShiftManagement = lazy(() => import("../src/screens/ShiftManagement"));
const SpareDashboard = lazy(() => import("../screen/SparePartsScreen/container/SpareDashboard"));
const SparesJobCard = lazy(() => import("../src/screens/SparesJobCard"));
const SparesJobCardDetails = lazy(() => import("../src/screens/SparesJobCardDetails"));
const SparesJobCardReplacePart = lazy(() => import("../src/screens/SparesJobCardReplacePart"));
const CareServices = lazy(() => import('../screen/v3/CareServices'))
const CatalogueManagementV2 = lazy(() => import("../src/screens/CatalogueManagementV2/CatalogueManagementV2"));

const switchNavigator = createSwitchNavigator(
  {
    Main: { screen: withAuth(DashboardScreen, "DashboardScreen") },
    CreateInvoice: { screen: withAuth(CreateInvoiceScreen, "CreateInvoiceScreen") },
    CreateInvoiceV1: { screen: withAuth(CreateInvoiceV1, "CreateInvoiceV1") },
    JobListListingScreen: { screen: withAuth(JobListListingScreen, "JobListListingScreen") },
    JobListListingScreenV3: { screen: withAuth(JobListListingScreenV3, "JobListListingScreenV3") },
    JobListListingScreenV1: { screen: withAuth(JobListListingScreenV1, "JobListListingScreenV1") },
    JobCardScreen: { screen: withAuth(JobCardScreen, "JobCardScreen") },
    JobCardScreenV1: { screen: withAuth(JobCardScreenV1, "JobCardScreenV1") },
    InvoiceListingScreen: { screen: withAuth(InvoiceListingScreen, "InvoiceListingScreen") },
    InvoiceListingScreenV1: { screen: withAuth(InvoiceListingScreenV1, "InvoiceListingScreenV1") },
    InvoiceListingScreenV3: { screen: withAuth(InvoiceListingScreenV3, "InvoiceListingScreenV3") },
    JobCardListingScreen: { screen: withAuth(JobCardListingScreen, "JobCardListingScreen") },
    JobCardListingScreenV1: { screen: withAuth(JobCardListingScreenV1, "JobCardListingScreenV1") },
    InventoryListingScreen: { screen: withAuth(InventoryListingScreen, "InventoryListingScreen") },
    InventoryListingScreenV1: { screen: withAuth(InventoryListingScreenV1, "InventoryListingScreenV1") },
    TicketDetailScreen: { screen: withAuth(TicketDetailScreen, "TicketDetailScreen") },
    ThreeSixtyViewUploadScreen: { screen: withAuth(ThreeSixtyViewUploadScreen, "ThreeSixtyViewUploadScreen") },
    ThreeSixtyViewScreen: { screen: ThreeSixtyViewScreen },
    ThreeSixtyInteriorViewScreen: { screen: ThreeSixtyInteriorViewScreen },
    WorkshopListingScreen: { screen: withAuth(WorkshopListingScreen, "WorkshopListingScreen") },
    UpComingInventoryScreen: { screen: withAuth(UpComingInventoryScreen, "UpComingInventoryScreen") },
    SparePartsScreen: { screen: withAuth(SparePartsScreen, "SparePartsScreen") },
    UpComingInventoryScreenV1: { screen: withAuth(UpComingInventoryScreenV1, "UpComingInventoryScreenV1") },
    // V3 screen
    DashboardV3: { screen: withAuth(DashboardV3, "DashboardV3") },
    WorkshopDashboard: { screen: withAuth(WorkshopDashboard, "WorkshopDashboard") },
    ReceivePartsTO: { screen: withAuth(ReceivePartsTO, "ReceivePartsTO") },
    RaiseRequest: { screen: withAuth(RaiseRequest, "RaiseRequest") },
    ReceivePartsVendor: { screen: withAuth(ReceivePartsVendor, "ReceivePartsVendor") },
    InventoryListingV3: { screen: withAuth(InventoryListingV3, "InventoryListingV3") },
    "InventoryListingV3.1": { screen: withAuth(InventoryListingV3New, "InventoryListingV3New") },
    UpcomingInventoryListingV3: { screen: withAuth(UpcomingInventoryListingV3, "UpcomingInventoryListingV3") },
    JobCardListingV3: { screen: withAuth(JobCardListingV3, "JobCardListingV3") },
    CarRefurbMetrics: { screen: withAuth(CarRefurbMetrics, "CarRefurbMetrics") },
    Purchase: { screen: withAuth(Purchase, "Purchase") },
    PendingConfirmation: { screen: withAuth(PendingConfirmation, "PendingConfirmation") },
    PendingInvoicing: { screen: withAuth(PendingInvoicing, "PendingInvoicing") },
    PendingReceiving: { screen: withAuth(PendingReceiving, "PendingReceiving") },
    OpenMarket: { screen: withAuth(OpenMarket, "OpenMarket") },
    OpenMarketConfirmation: { screen: withAuth(OpenMarketConfirmation, "OpenMarketConfirmation") },
    PurchaserModuleConfirmParts: { screen: withAuth(ConfirmParts, "PurchaserModuleConfirmParts") },
    PMInvoice: { screen: withAuth(PMInvoice, "PMInvoice") },
    InventoryReplenishment: { screen: withAuth(InventoryReplenishment, "InventoryReplenishment") },
    InvenRepPurchaseRequest: { screen: withAuth(InvenRepPurchaseRequest, "InvenRepPurchaseRequest") },
    PurchaseRequestByCar: { screen: withAuth(PurchaseRequestByCar, "PurchaseRequestByCar") },
    InvenRepEditPurchaseRequest: { screen: withAuth(InvenRepEditPurchaseRequest, "InvenRepEditPurchaseRequest") },
    PMSubmittedInvoiceDetails: { screen: withAuth(PMSubmittedInvoiceDetails, "PMSubmittedInvoiceDetails") },
    Budget: { screen: withAuth(Budget, "Budget") },
    BudgetDetails: { screen: withAuth(BudgetDetails, "BudgetDetails") },
    ByCarV2: { screen: withAuth(ByCarV2, "ByCarV2") },
    AlternatePartV2: { screen: withAuth(AlternatePartV2, "AlternatePartV2") },
    Inspections: { screen: withAuth(Inspections, "Inspections") },
    InspectionDetails: { screen: withAuth(InspectionDetails, "InspectionDetails") },
    CatalogueRequests: { screen: withAuth(CatalogueRequests, "CatalogueRequests") },
    NoAccess: { screen: NoAccess },
    Outbound: { screen: withAuth(Outbound, 'Outbound') },
    OutboundDashboard: { screen: withAuth(OutboundDashboard, "OutboundDashboard") },
    ShiftManagement: { screen: withAuth(ShiftManagement, "ShiftManagement") },
    ManPower: { screen: withAuth(ManPower, "ManPower")},
    Dispute: { screen: withAuth(Dispute, "Dispute") },
    Resolution: { screen: withAuth(Resolution, "Resolution") },
    DisputeManagementDetail: { screen: withAuth(DisputeManagementDetail, "DisputeManagementDetail") },
    ResolutionManagementDetail: { screen: withAuth(ResolutionManagementDetail, "ResolutionManagementDetail") },
    Warranty: { screen: withAuth(Warranty, "Warranty") },
    SpareDashboard: { screen: withAuth(SpareDashboard, "SpareDashboard") },
    SparesJobCard: { screen: withAuth(SparesJobCard, "SparesJobCard") },
    SparesJobCardDetails: { screen: withAuth(SparesJobCardDetails, "SparesJobCardDetails") },
    SparesJobCardReplacePart: { screen: withAuth(SparesJobCardReplacePart, "SparesJobCardReplacePart") },
    CareServices: { screen: withAuth(CareServices, 'CareServices') },
    CatalogueManagementV2: { screen: withAuth(CatalogueManagementV2, "CatalogueManagementV2") },
    Login: Login,
  },
  {
    initialRouteName: "Main",
  }
);

export default switchNavigator;
